import { defineRouting } from "next-intl/routing";
import { createNavigation } from "next-intl/navigation";

import { defaultLocale, locales } from "./config";

export const routing = defineRouting({
  locales,
  defaultLocale,
  /** Локаль берётся из URL, а не из куки: ссылку можно переслать. */
  localeDetection: false,
  /** `ru` живёт на `/`, остальные локали получают префикс: `/en`. */
  localePrefix: "as-needed"
});

const { Link, redirect, usePathname, useRouter } = createNavigation(routing);

export { Link, redirect, usePathname, useRouter, locales };
